import { DOCUMENT } from '@angular/common';
import { Component, inject, OnInit, Renderer2 } from '@angular/core';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './components/header/header.component';

@Component({
  standalone: true,
  imports: [HeaderComponent, RouterModule],
  selector: 'ntk-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  private document = inject(DOCUMENT);
  private renderer = inject(Renderer2);

  private readonly defaultTheme = 'empathy-theme';

  ngOnInit(): void {
    this.setTheme(this.defaultTheme);
  }

  private setTheme(themeName: string): void {
    const body = this.document.body;

    this.renderer.addClass(body, themeName);
  }
}
